/**
 * 上传管理api
 */
export default {
  selectUploadInfoPage: "/upload/selectUploadInfoPage", // 列表
}
